module.exports = __webpack_public_path__ + "img/newchris-2.172dcee9.jpg";